function navGlobal() {
	function navSlider() {
		// 展開社群 & 搜尋
		function open(target, navHeightOuter) {
			const $target = $(target);
			const $stickyWrapper = $("#sidebar_left-sticky-wrapper"); // 這個東西會包住NAV
			const isSticky = $stickyWrapper.hasClass("is-sticky");
			const isToggleHeight = $target.data("toggle-height");

			$target
				.data("toggle", 1)
				.stop()
				.slideDown(() => {
					// 打開後 focus 搜尋輸入框
					if ($target.find("input")) {
						$target.find("input").focus();
					}
				});

			if (!isSticky && !isToggleHeight) {
				$target.data("toggle-height", 1);
				$stickyWrapper.animate({
					height: "+=" + navHeightOuter,
				});
			}
		}

		function close(target, navHeightOuter, callback) {
			const $target = $(target);
			const $stickyWrapper = $(".header .sticky-wrapper");
			const isToggleHeight = $target.data("toggle-height");

			$target
				.data("toggle", 0)
				.stop()
				.slideUp(function () {
					if (callback && typeof callback === "function") callback();
				});

			if (isToggleHeight) {
				$target.data("toggle-height", 0);
				$stickyWrapper.animate({
					height: "-=" + navHeightOuter,
				});
			}
		}

		function toggle(target, navHeightOuter) {
			const $target = $(target);
			const $siblings = $target.siblings(".nav__slider");
			const isOpen = $target.data("toggle");

			if (isOpen) {
				close(target, navHeightOuter);
			} else {
				if ($siblings.data("toggle")) {
					close($siblings.get(0), navHeightOuter, function () {
						open(target, navHeightOuter);
					});
				} else {
					open(target, navHeightOuter);
				}
			}
		}

		function init() {
			const $el = $(".nav__slider");

			if ($el.length < 1) {
				return;
			}

			const navHeightOuter = $el.outerHeight(true);

			$el.data("toggle", 0);
			$el.data("toggle-height", 0);

			$("[data-nav-slider]").on("click", function (event) {
				// data-nav-slider就是CONNECT & SEARCH 兩個按鈕]
				const $this = $(this);
				const target = $($this.data("nav-slider")).get(0);
				// 挖出該a的文字

				toggle(target, navHeightOuter);
				// 展開它

				event.preventDefault();
			});

			$(".nav__slider__close").on("click", function (event) {
				const $this = $(this);
				const target = $this.parents(".nav__slider").get(0);

				close(target, navHeightOuter);

				event.preventDefault();
			});
		}

		init();
	}

	navSlider();
}

function navDesktop() {
	function fixSidebar() {
		$("#page-shop .main").css("min-height", $(".product-menu").height());
		$("#page-shop .product-menu").stick_in_parent(); // 貼頂套件
	}

	if (
		$("#list-content--new").length > 0 ||
		$("#list-content--normal").length > 0 ||
		$("#list-content--result").length > 0 ||
		$(".product-content").length > 0
	) {
		$(window).on("fixSidebar", fixSidebar);
	} else {
		fixSidebar();
	}
}

function navMobile() {
	const headerFixedCss = "js-headerShow";

	const $allList = $(".ALLITEM_list, .more_list, .member_list");

	function fixedHeader() {
		const $window = $(window);
		const headerHeight = 93;
		let p;
		let t;
		let listShow;

		$window.scroll(function () {
			p = $(this).scrollTop();

			if (p >= t && listShow === 0) {
				// 下滑且列表都沒有顯示時
				$("body").removeClass(headerFixedCss);
			} else if (p > headerHeight) {
				// 上滑且卷軸超過 header 高
				$("body").addClass(headerFixedCss);
			}

			setTimeout(function () {
				listShow = $(".ALLITEM_list, .member_list, .more_list").filter(":visible").length;
				// 避免關閉列表時立刻判斷成列表沒有顯示而觸發隱藏 header 事件
				t = p;
			}, 0);
		});
	}

	function topLevel() {
		// 第一層開關
		const $wrap = $(".home-content, .main, .index-wrap");
		const $globalNotice = $(".global-notice");

		const categoryButton = ".nav__women > a, .nav__women > a > span";
		const memberButton = ".account > a";
		const moreButton = ".more-box > a";
		const $allListButton = $(categoryButton).add($(memberButton)).add($(moreButton));

		const $CommunityBox = $(".Community-box");
		const $CommunityList = $(".Community_list");
		const $CommunityClose = $(".Community_close");

		let winScrollTop;

		//  社群以外的列表
		$allListButton.on("click", function (e, target) {
			e.preventDefault();

			$CommunityList.slideUp(); // 關閉社群列表
			$("body").addClass("js-headerShow"); // 顯示 header

			// 判斷 target
			if ($(e.target).is(categoryButton)) {
				target = ".ALLITEM_list";
			} else if ($(e.target).is(memberButton)) {
				target = ".member_list";
			} else if ($(e.target).is(moreButton)) {
				target = ".more_list";
			}

			// 如果所有列表都還沒開就記錄卷軸位置
			if ($allList.filter(":visible").length === 0) {
				winScrollTop = $(window).scrollTop();
			}

			// 如果自己沒開表示正要執行打開動作
			if ($(target).filter(":visible").length === 0) {
				$globalNotice.addClass("hide"); // 隱藏活動資訊
				$wrap.addClass("disappear"); // 避免重新 loading 造成畫面閃爍，使用css控制
				$(target).slideDown();
				$allList.not(target).slideUp(); // 除了自己以外的都hide吧
				$(window).scrollTop(0);
			} else {
				// 自己已經開了
				$globalNotice.removeClass("hide"); // 顯示活動資訊
				$wrap.removeClass("disappear");
				$(target).hide();
				$(window).scrollTop(winScrollTop);
			}

			// category可能target為span，需阻止事件冒泡
			e.stopPropagation();
		});

		// 展開社群
		$CommunityBox.on("click tough", function () {
			if ($CommunityList.filter(":visible").length > 0) {
				$CommunityList.slideUp();
				$CommunityClose.fadeOut();
			} else {
				$CommunityList.slideDown();
				$CommunityClose.fadeIn();
			}
		});

		// 關掉社群
		$CommunityClose.on("click tough", function () {
			$CommunityList.slideUp();
			$CommunityClose.fadeOut();
		});
	}

	function subLevel() {
		function resetAllList() {
			// 移除不要DER"全系列"
			const $AllListSub = $(".ALLITEM_list > li > ul");
			for (var i = 0; i <= $AllListSub.length; i++) {
				if ($AllListSub.eq(i).children("li").length === 2) {
					$AllListSub.eq(i).children("li").remove();
					// 如果只有兩個 表是一個是"全系列" 另一個是自己本身
					// 通通刪掉用展開的那個鈕來連結極可
				}
			}
		}

		function toggleSubLevel() {
			// 子層開關
			const $allListSubButton = $allList.find("a");
			$allListSubButton.on("click tough", function (e) {
				// 有子層才會跑
				if ($(this).next("ul").children("li").length > 0) {
					e.preventDefault();
					$(this).toggleClass("open").next("ul").slideToggle();
				}
			});
		}

		resetAllList();
		toggleSubLevel();
	}

	function tabStatus() {
		// 登入按鈕顯示
		if (nowEnv.NowIsLogin) {
			$("li.login").remove();
		} else {
			$("li.account").remove();
		}
	}

	if ($(".header").length > 0) {
		fixedHeader();
		topLevel();
		subLevel();
		tabStatus();
	}
}

export default {
	navGlobal: navGlobal,
	navDesktop: navDesktop,
	navMobile: navMobile,
};
